var $d70c2a849e55c607$exports = {};
$d70c2a849e55c607$exports = {
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`,
    "colorSwatchPicker": `Color swatches`
};


export {$d70c2a849e55c607$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
